import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const revokeInvite = (inviteUuid: string): ReturnType => {
    return Request.post(`/api/invites/revoke`, {
        invite: inviteUuid,
    });
};

export default revokeInvite;
